import { render, staticRenderFns } from "./Praatplaten.vue?vue&type=template&id=68f6c09b&scoped=true"
import script from "./Praatplaten.vue?vue&type=script&lang=js"
export * from "./Praatplaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f6c09b",
  null
  
)

export default component.exports